import { CheckAccessFunc, GetInvestigationName } from '../Components/CommonFunctions/CommonFunctions';
import { ImagePaths } from '../Utility/ImagePaths';
import { localGetItem } from './Services/CacheProviderService';

export class NewSideMenu {
    static FO = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        const { common } = UserData?.permission_access;
        let newList = [];

        if (UserData?.module_name === "front_office") {
            if (CheckAccessFunc("front_office", "Home", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: 'OPHome', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (CheckAccessFunc("front_office", "WalkIn", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: 'WalkInAdmission', OnIcon: ImagePaths.WalkinOn, OffIcon: ImagePaths.WalkinOff, label: "WalkIn" })
            }
            if (CheckAccessFunc("front_office", "In Patients", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 3, menuName: 'IPHome', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "IPHome" })
            }
            if (CheckAccessFunc("front_office", "Hospital Billing", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 4, menuName: 'Hospital Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Hospital Billing" })
            }
            // } else {
            //     if (CheckAccessFunc("front_office", "Billing", null, null, "Menu")?.viewAccess) {
            //         newList.push({ id: 6, menuName: 'Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
            //     }
            // }
            if (CheckAccessFunc("front_office", "Billing Transaction", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 5, menuName: 'Billing Transaction', OnIcon: ImagePaths.BillingOn, OffIcon: ImagePaths.BillingOff, label: 'Billing Transaction' })
            }
            // if ((localGetItem('isNewBilling') === 'true') && UserData?.enable_credit_settlement) {
            //         newList.push({ id: 8, menuName: 'Credit Settlement', OnIcon: ImagePaths.Settlementon, OffIcon: ImagePaths.Settlementoff, label: 'Credit Settlement' })
            // }
            if (CheckAccessFunc("front_office", "Reports", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 6, menuName: 'FOReports', OnIcon: ImagePaths.LabReportOn, OffIcon: ImagePaths.LabReportOff, label: 'Reports' })
            }
            if (CheckAccessFunc("front_office", "Settings", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 7, menuName: 'Settings', OnIcon: ImagePaths.LabSettingOn, OffIcon: ImagePaths.LabSettingOff, label: "Settings" })
            }
            // if (UserData?.is_user ? common?.can_view_dashboard === true : true) {
            //     newList.push({ id: 7, menuName: 'ChartDashboard', OnIcon: ImagePaths.ChartDashboardOn, OffIcon: ImagePaths.ChartDashboardOff, label: "Dashboard" })
            // }
            // if (UserData?.is_super_admin && localGetItem('isNewBilling') === 'true') {
            //     newList.push({ id: 8, menuName: 'Revert', OnIcon: ImagePaths.Revertonicon, OffIcon: ImagePaths.Revertofficon, label: "Revert" })
            // }
            // if (localGetItem('isNewBilling') === 'true' && CheckAccessFunc("front_office", "Mrd", null, null, "Menu")?.viewAccess) {
            //     newList.push({ id: 9, menuName: 'FO MRD', OnIcon: ImagePaths.MRDOnIcon, OffIcon: ImagePaths.MRDOffIcon, label: "MRD" })
            // }                

        }
        return newList;
    }

    static Nurse = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "nurse") {
            if (CheckAccessFunc("front_office", "Home", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: 'OPHome', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (CheckAccessFunc("front_office", "In Patients", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: 'IPHome', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "IPHome" })
            }
            newList.push({ id: 3, menuName: 'NurseTask', OnIcon: ImagePaths.NurseTaskOn, OffIcon: ImagePaths.NurseTaskOff, label: "Task" })
          
            // if (localGetItem('isNewBilling') === 'true' && UserData?.enable_mrd) {
            //     newList.push({ id: 3, menuName: 'Doctor MRD', OnIcon: ImagePaths.MRDOnIcon, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.MRDOffIcon, label: "MRD" })
            // }
        }
        return newList;
    }

    static Doctor = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];
        let enable_billing = localGetItem('enable_billing') === 'true' ? true : false
        let enable_bill_trans = localGetItem('enable_billing_transaction') === 'true' ? true : false

        newList.push({ id: 1, menuName: 'Doctor Home', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
        newList.push({ id: 2, menuName: 'WalkInAdmission', OnIcon: ImagePaths.WalkinOn, OffIcon: ImagePaths.WalkinOff, label: "WalkIn" })
        newList.push({ id: 7, menuName: 'IP Doctor Home', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "IPHome" })
        if (true && enable_billing) {
            newList.push({ id: 8, menuName: 'Doctor Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: 'Billing' })
        }
        // newList.push({ id: 2, menuName: 'Doctor Nutrition Chart', OnIcon: ImagePaths.DocNutritionOn, OffIcon: ImagePaths.DocNutritionOff, label: "Nutrition Chart" })
        // if (true && enable_billing && UserData?.service_type === "OPT") {
        //     newList.push({ id: 8, menuName: 'Doctor Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: 'Billing' })
        // }
        // if (true && enable_bill_trans) {
        //     newList.push({ id: 9, menuName: 'Billing Transaction', OnIcon: ImagePaths.BillingOn, OffIcon: ImagePaths.BillingOff, label: 'Billing Transaction' })
        // }
        // if (true) {
        //     newList.push({ id: 3, menuName: 'Doctor Registry', OnIcon: ImagePaths.DocRegistryOn, OffIcon: ImagePaths.DocRegistryOff, label: "Registry" })
        // }
        // if (localGetItem('isNewBilling') === 'true' && UserData?.enable_mrd) {
        //     newList.push({ id: 8, menuName: 'Doctor MRD', OnIcon: ImagePaths.MRDOnIcon, OffIcon: ImagePaths.MRDOffIcon, label: "MRD" })
        // }
        // if (UserData?.service_type === "OPT") {
        //     newList.push({ id: 5, menuName: 'Doctor Reports', OnIcon: ImagePaths.LabReportOn, OffIcon: ImagePaths.LabReportOff, label: "Reports" })
        // }
        newList.push({ id: 6, menuName: 'Doctor Settings', OnIcon: ImagePaths.LabSettingOn, OffIcon: ImagePaths.LabSettingOff, label: "Settings" })
        return newList;
    }
    static lab = () => {
        const myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false")
        let newList = [];

        if (myUser?.module_name === "Laboratory") {
            if (CheckAccessFunc("Laboratory", "Home", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: 'MainHome', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (CheckAccessFunc("Laboratory", "Reports", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: 'LabReports', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabReportOff, label: "Reports" })
            }
            if (CheckAccessFunc("Laboratory", "Lab Billing", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 3, menuName: 'LabBilling', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
            }
            // if (CheckAccessFunc("Laboratory", "Inventory", null, null, "Menu")?.viewAccess) {
            //     newList.push({ id: 4, menuName: 'Inventory', OnIcon: ImagePaths.LabInventryOn, OffIcon: ImagePaths.LabInventrytOff, label: "Inventory" })
            // }
            // if (CheckAccessFunc("Laboratory", "Purchase", null, null, "Menu")?.viewAccess) {
            //     newList.push({ id: 5, menuName: 'Purchase', OnIcon: ImagePaths.LabPurchaseOn, OffIcon: ImagePaths.LabPurchaseOff, label: "Purchase" })
            // }
            if (CheckAccessFunc("Laboratory", "Settings", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 6, menuName: 'labSettings', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
            return newList;
        }
    }

    static Ayurveda = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];
        if (CheckAccessFunc("Ayurveda", "Counsellor", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 1, menuName: 'Ayurveda Counsellor', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Counsellor" })
        }
        if (CheckAccessFunc("Ayurveda", "WalkIn", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 2, menuName: 'Ayurveda Counsellor Walkin', OnIcon: ImagePaths.WalkinOn, OffIcon: ImagePaths.WalkinOff, label: "WalkIn" })
        }
        if (CheckAccessFunc("Ayurveda", "Scheduler", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 3, menuName: 'Ayurveda Scheduler', OnIcon: ImagePaths.SchedulerOn, OffIcon: ImagePaths.SchedulerOff, label: "Scheduler" })
        }
        if (CheckAccessFunc("Ayurveda", "Madication", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 4, menuName: 'Ayurveda Medication', OnIcon: ImagePaths.MedicationOn, OffIcon: ImagePaths.MedicationOff, label: "Medication" })
        }
        if (CheckAccessFunc("Ayurveda", "Therapist", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 5, menuName: 'Ayurveda Therapist', OnIcon: ImagePaths.WalkinOn, OffIcon: ImagePaths.WalkinOff, label: "Therapist" })
        }
        if (CheckAccessFunc("Ayurveda", "Madication", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 6, menuName: 'Ayurveda Medicine Creation', OnIcon: ImagePaths.MedicationOn, OffIcon: ImagePaths.MedicationOff, label: "Medicine Creation" })
        }
        // if (CheckAccessFunc("Ayurveda", "Reports", null, null, "Menu")?.viewAccess) {
        //     newList.push({ id: 5, menuName: 'Ayurveda Reports', OnIcon: ImagePaths.LabReportOn, OffIcon: ImagePaths.LabReportOff, label: 'Reports' })
        // }
        // if (CheckAccessFunc("Ayurveda", "Settings", null, null, "Menu")?.viewAccess) {
        //     newList.push({ id: 6, menuName: "Ayurveda Setting", OnIcon: ImagePaths.LabSettingOn, OffIcon: ImagePaths.LabSettingOff, label: "Masters" })
        // }
        return newList;
    }

    static Radiology = () => {
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false")
        let newList = [];
        let ModuleName = GetInvestigationName();

        if (true) {
            newList.push({ id: 1, menuName: `${ModuleName} Home`, OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
        }
        if (CheckAccessFunc(ModuleName, `${ModuleName} Billing`, null, null, "Menu")?.viewAccess) {
            newList.push({ id: 5, menuName: `${ModuleName} Billing`, OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
        }
        if (CheckAccessFunc(ModuleName, "Billing Transaction", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 2, menuName: `${ModuleName} Billing Transaction`, OnIcon: ImagePaths.BillingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.BillingOff, label: 'Billing Transaction' })
        }
        if (CheckAccessFunc(ModuleName, "Order", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 6, menuName: `${ModuleName} Order`, OnIcon: ImagePaths.OrderOnIcon, OffIcon: ImagePaths.OrderOffIcon, label: 'Order' })
        }
        if (CheckAccessFunc(ModuleName, "Reports", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 3, menuName: `${ModuleName} Reports`, OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabReportOff, label: 'Reports' })
        }
        if (CheckAccessFunc(ModuleName, "Settings", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 4, menuName: `${ModuleName} Settings`, OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
        }
        return newList;
    }

    static Pharmacy = () => {
        const UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        const internalStoreEnabled = JSON.parse(localGetItem("internalStoreEnabled"))
        const mainPharmacyEnabled = JSON.parse(localGetItem("mainPharmacyEnabled"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false")
        const newList = [];
        const pharmacy_type = UserData?.pharmacy_type === 'Inhouse Pharmacy' ? "Pharmacy" : "Standalone Pharmacy";

        if (UserData?.module_name === 'Pharmacy') {
            if (CheckAccessFunc(pharmacy_type, "Billing", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: "Pharmacy Billing", OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
            }
            if (CheckAccessFunc(pharmacy_type, "Billing Transaction", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: "Pharmacy Invoice", OnIcon: ImagePaths.BillingOn, OffIcon: subscription_expired ? ImagePaths.Billing_restrict : ImagePaths.BillingOff, label: "Billing Transaction" })
            }
            if (CheckAccessFunc(pharmacy_type, "Inventory", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 3, menuName: "Pharmacy Inventory", OnIcon: ImagePaths.LabInventryOn, OffIcon: ImagePaths.LabInventrytOff, label: "Inventory" })
            }
            if ((CheckAccessFunc(pharmacy_type, "Purchase", null, null, "Menu")?.viewAccess) && UserData?.is_po_enabled) {
                newList.push({ id: 4, menuName: "Pharmacy Purchase", OnIcon: ImagePaths.LabPurchaseOn, OffIcon: ImagePaths.LabPurchaseOff, label: "Purchase" })
            }
            if (CheckAccessFunc(pharmacy_type, "Reports", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 5, menuName: "Pharmacy Reports", OnIcon: ImagePaths.LabReportOn, OffIcon: ImagePaths.LabReportOff, label: "Report" })
            }
            if ((internalStoreEnabled) && (mainPharmacyEnabled) && (CheckAccessFunc(pharmacy_type, "Internal Sales", null, null, "Menu")?.viewAccess)) {
                newList.push({ id: 6, menuName: "Pharmacy Internal Sales", OnIcon: ImagePaths.InternalSalesOn, OffIcon: ImagePaths.InternalSalesOff, label: "Internal Sales" })
            }

            if (UserData?.pharmacy_type === "Inhouse Pharmacy" && CheckAccessFunc("Pharmacy", "Stock Transfer", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 7, menuName: 'Pharmacy Stock Transfer', OnIcon: ImagePaths.StkTransferOn, OffIcon: ImagePaths.StkTransferOff, label: 'Stock Transfer' })
            }
            if (CheckAccessFunc(pharmacy_type, "Settings", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 8, menuName: "Pharmacy Setting", OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
            // if (UserData?.is_super_admin) {
            //     newList.push({ id: 9, menuName: "Pharmacy GST Update", OnIcon: ImagePaths.ChartDashboardOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.ChartDashboardOff, label: "GST Update" })
            // }
            return newList;
        }
    }

    static JMO = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "JMO") {
            newList.push({ id: 1, menuName: 'Doctor Home', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            newList.push({ id: 2, menuName: 'IP Doctor Home', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "IPHome" })
            // newList.push({ id: 3, menuName: 'Doctor Registry', OnIcon: ImagePaths.DocRegistryOn, OffIcon: ImagePaths.DocRegistryOff, label: "Registry" })
        }
        return newList;
    }

    static SubLocation = () => {
        let newList = [];
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false")
        if (CheckAccessFunc("sub_location", "Home", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 1, menuName: "SubLocation Billing", OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
        }
        if (CheckAccessFunc("sub_location", "Reports", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 2, menuName: "SubLocation Reports", OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Report" })
        }
        if (CheckAccessFunc("sub_location", "Stock Transfer", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 3, menuName: "SubLocation Stock Transfer", OnIcon: ImagePaths.StkTransferOn, OffIcon: ImagePaths.StkTransferOff, label: "Stock Transfer" })
        }
        return newList;
    }
}